export default __webpack_public_path__ + "static/media/smartobject_pink.d1b0659a.png";